import { render, staticRenderFns } from "./ZaloListModal.vue?vue&type=template&id=00279ec3&scoped=true"
import script from "./ZaloListModal.vue?vue&type=script&lang=js"
export * from "./ZaloListModal.vue?vue&type=script&lang=js"
import style0 from "./ZaloListModal.vue?vue&type=style&index=0&id=00279ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00279ec3",
  null
  
)

export default component.exports